
import React from 'react';
import {Route, Routes } from 'react-router-dom';
import Error404 from '../Pages/Error404';
import {
  Login,
  SFAUserMapping,
  SFAForgetPassword,
  SFANewpassword,
  SFAChangePassword,
  SFACondonation
} from "../Pages/SFA";



import ProtectedRoute from '../component/ProtectedRoute';

const SFARoutes = () => (

  <Routes>

    <Route path="/*" element={<Error404 />} />
    <Route path="/" element={<Login />} />
    <Route path="/sfaforgetpassword" element={<SFAForgetPassword />} />
    <Route path="/sfanewpassword" element={<SFANewpassword />} />

    <Route path="/sfausermapping" element={<ProtectedRoute element={<SFAUserMapping />} role={22} />} />
    <Route path="/sfachangepassword" element={<ProtectedRoute element={<SFAChangePassword />} role={22} />} />
    <Route path="/condonation" element={<ProtectedRoute element={<SFACondonation />} role={22} />} />

  </Routes>

);

export default SFARoutes;

